import { Separator } from '@/components/ui/separator';

/**
 * A rule between two menu blocks. Placed by the composition, never by a block:
 * blocks come and go per area, and a rule that belongs to one of them ends up
 * doubled or missing the moment its neighbour disappears.
 */
export function UserMenuSeparator() {
  return <Separator />;
}
